import { AxiosPromise } from 'axios';
import { apiInstance } from 'shared/api/base';
import { Car } from 'shared/api/types';

const cars = [
  {
    id: 1,
    date: '2022-10-09T05:36:56.559Z',
    name: 'BMW',
    count: 2,
    distance: 210,
  },
  {
    id: 2,
    date: '2022-10-09T05:47:45.022Z',
    name: 'Mercedes',
    count: 3,
    distance: 20,
  },
  {
    id: 3,
    date: '2022-10-09T05:48:04.579Z',
    name: 'Audi',
    count: 10,
    distance: 100,
  },
  {
    id: 4,
    date: '2022-10-09T05:48:18.961Z',
    name: 'Ford',
    count: 5,
    distance: 322,
  },
  {
    id: 5,
    date: '2022-10-09T05:48:31.940Z',
    name: 'Honda',
    count: 18,
    distance: 548,
  },
  {
    id: 6,
    date: '2022-10-09T05:48:43.809Z',
    name: 'Hyundai',
    count: 7,
    distance: 52,
  },
  {
    id: 7,
    date: '2022-10-09T05:48:54.676Z',
    name: 'Kia',
    count: 14,
    distance: 86,
  },
  {
    id: 8,
    date: '2022-10-09T05:49:05.523Z',
    name: 'Mazda',
    count: 1,
    distance: 103,
  },
  {
    id: 9,
    date: '2022-10-09T05:49:30.421Z',
    name: 'Mitsubishi',
    count: 2,
    distance: 600,
  },
  {
    id: 10,
    date: '2022-10-09T05:50:26.478Z',
    name: 'Skoda',
    count: 22,
    distance: 573,
  },
];

export const getCarsList = (): Promise<Car[]> => {
  return new Promise((rs) => {
    setInterval(() => rs(cars), 500);
  });
};
